import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// Customer-console Firebase Auth (its own pool in the captomi-console project). Config comes
// from build-time env (VITE_FIREBASE_*); the real values are filled once the Firebase web app
// is registered (deploy increment, gated on captomi-console billing). For local dev/CI, point
// VITE_AUTH_EMULATOR at the Auth emulator — any apiKey works against it.
// On the vanity signup host, authDomain follows the serving host so signInWithPopup stays
// SAME-ORIGIN (Firebase Hosting serves /__/auth/* on every connected domain; a cross-origin
// authDomain breaks popup auth under third-party-storage partitioning in Safari/Firefox).
// Requires the Google OAuth client to list this host's /__/auth/handler — see DEPLOY.md.
const auth_domain =
  window.location.hostname === 'signup.captomi.com'
    ? 'signup.captomi.com'
    : import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'captomi-console.firebaseapp.com';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'demo-key',
  authDomain: auth_domain,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'captomi-console',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const emulator = import.meta.env.VITE_AUTH_EMULATOR; // e.g. http://localhost:9099
if (emulator) {
  connectAuthEmulator(auth, emulator, { disableWarnings: true });
}
